export default __webpack_public_path__ + "static/media/doctor_comments.a69f56f3.svg";